
import { Col, Row } from "react-bootstrap";
import Button from "./Button/Button";
import Select from "./Select/Select";
import TextField from "./TextField";
import TimePicker from "./TimePicker";

const variants = [
    "primary",
    "outline-primary",
    "secondary",
    "outline-secondary",
    "danger",
    "outline-danger",
    "success",
    "outline-success",
];

const sizes = [
    { key: "sm", label: "Small" },
    { key: "md", label: "Medium" },
    { key: "lg", label: "Large" },
    { key: "md", label: "isLoading" },
    { key: "md", label: "Disabled" },
];

export default function Design() {
    return (
        <Row className="w-100">
            <Col sm={2}>
                <h2 className="border-bottom mb-3 text-center">Buttons</h2>
                {variants.map((variant) => {
                    const heading = variant
                        .replace("outline-", "Outline ")
                        .replace(/^\w/, (c) => c.toUpperCase());
                    return (
                        <section key={variant} className="mb-2">
                            <h3>{heading}</h3>
                            <div className="d-flex flex-column gap-2">
                                {sizes.map(({ key: sizeKey, label: sizeLabel }) => (
                                    <Button
                                        disabled={sizeLabel === "Disabled"}
                                        isLoading={sizeLabel === "isLoading"}
                                        key={`${variant}-${sizeKey}`}
                                        variant={variant}
                                        size={sizeKey}
                                    >
                                        {sizeLabel}
                                    </Button>
                                ))}
                            </div>
                        </section>
                    );
                })}
            </Col>
            <Col sm={2}>
                <h2 className="border-bottom mb-3 text-center">Select Dropdown</h2>
                <div className="d-flex flex-column">
                    <div className="mb-3">
                        <h3>Primary</h3>
                        <Select options={sizes.map(s => { return { value: s.key, label: s.label } })} label="Size Small" size="sm" className="mb-2" />
                        <Select options={sizes.map(s => { return { value: s.key, label: s.label } })} label="Size Large" size="lg" />
                    </div>
                    <div>
                        <h3>Error State</h3>
                        <Select options={sizes.map(s => { return { value: s.key, label: s.label } })} label="Size Small" size="sm" error={{ message: "Field is Required" }} />
                        <Select options={sizes.map(s => { return { value: s.key, label: s.label } })} label="Size Large" size="lg" error={{ message: "Field is Required" }} />
                    </div>
                </div>
            </Col>
            <Col sm={2}>
                <h2 className="border-bottom mb-3 text-center">Text Field</h2>
                <div className="d-flex flex-column">
                    <div className="mb-3">
                        <h3>Primary</h3>
                        <TextField
                            size="sm"
                            label="Small Label"
                            className="mb-2"
                        />
                        <TextField
                            size="lg"
                            label="Large Label"
                        />
                    </div>
                    <div>
                        <h3>Error State</h3>
                        <TextField
                            size="sm"
                            error="Field is Required"
                            label="Large Label"
                        />
                        <TextField
                            size="lg"
                            error="Field is Required"
                            label="Small Label"
                        />
                    </div>
                </div>
            </Col>
            <Col sm={2}>
                <h2 className="border-bottom text-center mb-3">Time Picker</h2>
                <div className="d-flex flex-column ">
                    <div className="mb-3">
                        <h3>Primary</h3>
                        <TimePicker label="Time Label" size="sm" className="mb-2" />
                        <TimePicker label="Time Label" size="lg" />
                    </div>
                    <div>
                        <h3>Error State</h3>
                        <TimePicker label="Time Label" size="sm" error={{ message: "Field is Required" }} />
                        <TimePicker label="Time Label" size="lg" error={{ message: "Field is Required" }} />
                    </div>
                </div>
            </Col>
        </Row>
    );
}
